import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { inject, observer } from 'mobx-react'
import LoadingWrapper from '../../LoadingWrapper'
import { Button, Form, Grid, Header } from 'semantic-ui-react'
import moment from 'moment'
import { withRouter } from 'react-router-dom'

@inject('eventsStore')
@withRouter
@observer
class Summary extends Component {
  static propTypes = {
    eventsStore: PropTypes.object,
    history: PropTypes.object
  }

  handleSubmitEvent = () => {
    const { eventsStore, history } = this.props
    eventsStore.completeEvent().then((result) => {
      if (result.success) {
        history.push({
          pathname: '/events'
        })
      }
    })
  }

  handleRejectEvent = () => {
    const { eventsStore } = this.props
    eventsStore.rejectEvent().then((result) => {
      if (result.success) {
        history.push({
          pathname: '/events'
        })
      }
    })
  }

  render () {
    const { eventsStore } = this.props
    const { event, isLoading, isSaving, forms } = eventsStore
    if (isLoading || !event) {
      return (<><LoadingWrapper loading={isLoading} message='Chargement en cours...' /></>)
    }
    return (
      <>
        <Header as='h1'>Confirmation de soumission d'inspection</Header>
        <LoadingWrapper loading={isSaving} message='Sauvegarde en cours...' />
        <Form>
          <Grid>
            <Grid.Row columns='equal'>
              <Grid.Column>
                <Header as='h3'>Client</Header>
                {event.client.name}
              </Grid.Column>
              <Grid.Column>
                <Header as='h3'>Technicien</Header>
                {event.user.fullName}
              </Grid.Column>
            </Grid.Row>
            <Grid.Row columns='equal'>
              <Grid.Column>
                <Header as='h3'>Adresse</Header>
                {event.clients_addresses_equipment.clients_address.address.fullAddress}
              </Grid.Column>
              <Grid.Column>
                <Header as='h3'>Début de l'inspection</Header>
                {!!event.starting_date && moment.utc(event.starting_date).format('HH:mm DD-MM-YYYY')}
                {!event.starting_date && 'N/D'}
              </Grid.Column>
            </Grid.Row>
            <Grid.Row columns='equal'>
              <Grid.Column>
                <Header as='h3'>Heure de l'inspection</Header>
                {moment.utc(event.date_start).format('HH:mm DD-MM-YYYY')}
              </Grid.Column>
              <Grid.Column>
                <Header as='h3'>Heure de remise</Header>
                {moment.utc(event.submitted_date).format('HH:mm DD-MM-YYYY')}
              </Grid.Column>
            </Grid.Row>
            <Grid.Row columns='equal'>
              <Grid.Column>
                <Header as='h3'>Équipement</Header>
                {event.clients_addresses_equipment.equipment.name}
              </Grid.Column>
              <Grid.Column>
                <Header as='h3'>Conformité choisi</Header>
                {event.conformStatus}
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <Header as='h3'>Formulaires</Header>
                {forms.map(form => form.code).join(', ')}
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <Header as='h3'>Statut inspection</Header>
                {event.statusName}
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <Header as='h3'>Temps restant</Header>
                {event.remainingTime}
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <Header as='h3'>Notes</Header>
                {event.notes ? event.notes : 'Aucune'}
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <Button floated='right' color='red' onClick={this.handleRejectEvent}>Retourner à l'inspecteur</Button>
                <Button primary content='Vérification Complétée' onClick={this.handleSubmitEvent} />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Form>
      </>
    )
  }
}

export default Summary
